import { Component } from '@angular/core';
import { SearchFormService } from '../core/services/search-form.service';
import { Router } from '@angular/router';
import { Employee } from '../core/models/employee.model';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/observable/of';
import { TypeaheadMatch } from "ngx-bootstrap";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
    selector: 'app-search-form',
    templateUrl: './search-form.component.html',
    styleUrls: ['./search-form.component.css'],
    providers: [SearchFormService]
})
export class SearchFormComponent {

    employees: Employee[] = [];
    submitForm: FormGroup;

    constructor(
        private router: Router,
        private fb: FormBuilder
    ) {
        this.submitForm = this.fb.group({
            'name': [''],

        });
    }

    onSubmit() {
        let value = this.submitForm.value;

        this.router.navigateByUrl('search-results?query=' + value['name']);


    }


}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/search-form/search-form.component.ts